var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"w1200"},[_c('ul',{staticClass:"list_box"},_vm._l((_vm.list),function(item){return _c('li',{key:item.id,staticClass:"list_item",on:{"click":function($event){return _vm.goDetails(item)}}},[_vm._v(_vm._s(item.service_name))])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }